import React,{useState,}from 'react'
import { Modal} from 'antd';
import BalanceDesc from '../balance/BalanceDesc';
function LedgerCostCheck(props) {
    const [open,setOpen] = useState()   
   
    return (
        <>
            <a onClick={() => {
                setOpen(true)}}>
                    {props.titleType==='数字' ? props.eie_id : '查看'}
                </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                width={1190}
                onCancel={() => {setOpen(false);}} 
                footer={null}                                      
            >
                <BalanceDesc
                    eie_id={props.eie_id}
                    title={props.title}
                />         
            </Modal>
        </>
    )
}

export default LedgerCostCheck